import {useContext} from 'react';

import EmmaiContext from '../../contexts/EmmaiContext';

const useEmmai = () => {
  return useContext(EmmaiContext);
};

export default useEmmai;
